import axios from 'axios'
import store from './store'
import router from './router'
import Vue from 'vue'

const instance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND
})

instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('jwt')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }

        const lang = localStorage.getItem('lang') || 'th'
        config.headers['Accept-Language'] = lang
        return config
    },

    error => {
        Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {
        if (response && response.data.status === 'error') {
            store.dispatch('setLoading', false)
            Vue.notify({
                title: router.app.$vuetify.lang.t('$vuetify.errorModal.errorMessage'),
                text: response.data.msg,
                type: 'notify-error'
            })
        }

        return response
    },
    function (error) {
        if (error && error.response && error.response.status === 401) {
            router.push({ name: 'Login' }, () => {})
            const message = error.response.data
            if (!(typeof message === 'string' && message.startsWith('Error:'))) {
                store.dispatch('setErrorModalShow', true)
                store.dispatch('setErrorModalMsg', error.response.data)
                store.dispatch('setLoading', false)
            }

            localStorage.setItem('jwt', null)
            localStorage.setItem('username', null)
        } else if (error && error.response && error.response.status === 500) {
            store.dispatch('setErrorModalShow', true)
            store.dispatch('setErrorModalMsg', error.response.data)
            store.dispatch('setLoading', false)
        } else if (error && error.response && error.response.status === 408) {
            store.dispatch('setLoading', false)
            return error.response
        }
    }
)

export default instance
